export default __webpack_public_path__ + "static/media/image.pahanmi-pvt-ltd.fd973434.png";